import { Navigate, useSearchParams } from "react-router";

export const PageMap = {
    ACCOUNT_CONFIRMATION: "accountConfirmation",
    ACCOUNT_SECURITY: "accountSecurity",
    INVITATION: "invitation",
    LOGIN: "login",
    LOGOUT: "logout",
    PASSWORD_CHANGE: "passwordChange",
    PASSWORD_RECOVER: "passwordRecover",
    PASSWORD_RESET: "passwordReset",
    PRODUCT: "product",
};

function getRedirectParams(searchParams: URLSearchParams) {
    const params = new URLSearchParams(searchParams);
    params.delete("page");
    return params;
}

function handleDashboardProductPage(sanitizedParams: URLSearchParams) {
    const params = new URLSearchParams(sanitizedParams);
    const codename = params.get("codename");
    const version = params.get("version");

    if (codename && version) {
        return <Navigate to={"/dashboard/products/" + codename + "/" + version} replace />;
    }

    return <Navigate to={"/dashboard/products?" + params.toString()} replace />;
}

function handlePasswordChangePage(sanitizedParams: URLSearchParams) {
    const params = new URLSearchParams(sanitizedParams);
    params.set("mode", "password");
    return <Navigate to={"/account/settings/security?" + params.toString()} replace />;
}

export const RedirectService = () => {
    const [searchParams] = useSearchParams();
    const sanitizedParams = getRedirectParams(searchParams);

    const page = searchParams.get("page");
    switch (page) {
        case PageMap.ACCOUNT_CONFIRMATION:
            return <Navigate to={"/account/confirm?" + sanitizedParams.toString()} replace />;
        case PageMap.ACCOUNT_SECURITY:
            return <Navigate to={"/account/settings/security?" + sanitizedParams.toString()} replace />;
        case PageMap.INVITATION:
            return <Navigate to={"/invitation?" + sanitizedParams.toString()} replace />;
        case PageMap.LOGIN:
            return <Navigate to={"/login?" + sanitizedParams.toString()} replace />;
        case PageMap.LOGOUT:
            return <Navigate to={"/logout?" + sanitizedParams.toString()} replace />;
        case PageMap.PASSWORD_CHANGE:
            return handlePasswordChangePage(sanitizedParams);
        case PageMap.PASSWORD_RECOVER:
            return <Navigate to={"/account/recover?" + sanitizedParams.toString()} replace />;
        case PageMap.PASSWORD_RESET:
            return <Navigate to={"/account/reset?" + sanitizedParams.toString()} replace />;
        case PageMap.PRODUCT:
            return handleDashboardProductPage(sanitizedParams);
        default:
            return <Navigate to="/" replace />;
    }
};
